<template>
<div class="project">
  <div v-if="!isLocalConfig">
    <el-card class="box-card" shadow="never">
      <el-button icon="el-icon-back" v-if="active != -1" style="float: left;" type="primary" @click="setActive(-1)">返回项目列表</el-button>
      <div v-if="active != -1" style="width: 80%;margin: 0px auto;font-size: 14px;">
        <el-steps :active="active" align-center process-status="finish" finish-status="wait">
          <el-step title="项目配置" @click.native="setActive(0)"></el-step>
          <el-step title="指标配置" @click.native="setActive(1)"></el-step>
          <el-step title="设备配置" @click.native="setActive(2)"></el-step>
          <el-step title="元数据配置" @click.native="setActive(3)"></el-step>
          <el-step title="数据面板绑定" @click.native="setActive(4)"></el-step>
          <!-- <el-step title="模板配置" @click.native="setActive(4)"></el-step> -->
          <el-step title="电芯配置" @click.native="setActive(5)"></el-step>
          <el-step title="热力图配置" @click.native="setActive(6)"></el-step>
          <el-step title="3D设备配置" @click.native="setActive(7)"></el-step>
          <el-step title="聚合点配置" @click.native="setActive(8)"></el-step>
        </el-steps>
      </div>
      <div class="wrap-page">
        <div v-show="active == -1">
          <el-form ref="form" :inline="true">
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="addRow">添加</el-button>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchKey" clearable placeholder="请输入关键字" @keyup.enter.native="searchKeywords" style="width: 250px;"></el-input>
              <el-button icon="el-icon-search" type="primary" @click="searchKeywords" @keyup.enter.native="searchKeywords">搜索</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tableData" ref="tbl" border max-height="600" style="width: 100%;margin-top: 10px;" tooltip-effect="dark" @cell-mouse-enter="cellMouseEnter">
            <el-table-column prop="projectId" label="项目编号" width="150" fixed></el-table-column>
            <el-table-column prop="projectName" label="项目名称" width="200" fixed show-overflow-tooltip></el-table-column>
            <el-table-column prop="owner" label="使用方名称" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productType" label="产品类型" width="150">
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.productType, productTypeOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="batteryType" label="电池类型" width="150">
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.batteryType, batteryTypeOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="batteryManufacturers" label="电池厂商" width="200">
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.batteryManufacturers, batteryManufacturersOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="energyStorageCapacity" label="储能容量" width="120"></el-table-column>
            <el-table-column prop="location" label="项目坐标" width="180"></el-table-column>
            <el-table-column prop="transformerCapacity" label="变压器容量" width="120"></el-table-column>
            <el-table-column prop="solarCapacity" label="光伏容量" width="120"></el-table-column>
            <el-table-column prop="energyStoragePower" label="储能功率" width="120"></el-table-column>
            <el-table-column prop="status" label="项目状态" width="100">
              <template slot-scope="{ row }">
                {{ statusDesc(row.status) }}
              </template>
            </el-table-column>
            <el-table-column prop="isShow" label="是否显示" width="100">
              <template slot-scope="{ row }">
                {{ row.isShow == 1 ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="startTime" label="投运时间" width="180"></el-table-column>
            <el-table-column prop="locationStr" label="项目地点" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="manufacturerType" label="使用方类型" width="160">
              <template slot-scope="{ row }">
                {{ COMM.getTypeOptions(row.manufacturerType, manufacturerTypeOptions, 'id', 'name') }}
              </template>
            </el-table-column>
            <el-table-column prop="priceId" label="电价组合" width="180">
              <template slot-scope="{ row }">
                {{ getPriceName(row.priceId) }}
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="250" align="center">
              <template slot-scope="{ row }">
                <!-- <el-button class="btn" type="text" size="small" @click="row.edit = !row.edit">修改</el-button> -->
                <el-button class="btn" type="text" size="small" @click="toProjectConfig(row)">配置</el-button>
                <el-button class="btn" type="text" size="small" @click="toLocalConfig(row)">本地配置</el-button>
                <el-button class="btn" type="text" size="small" @click="exportLocal(row)">导出</el-button>
                <!-- <el-button class="btn" type="text" size="small" @click="toProjectSecondModuleConfig(row)">指标配置</el-button>
              <el-button class="btn" type="text" size="small" @click="toProjectUpdateOrder(row)">模块排序</el-button>
              <el-button class="btn" type="text" size="small" @click="toProjectAlgorithm(row)">算法配置</el-button>
              <el-button class="btn" type="text" size="small" @click="toProjectTemplateConfig(row)">模板配置</el-button>
              <el-button class="btn" type="text" size="small" @click="toProjectCellConfig(row)">电芯配置</el-button>
              <el-button class="btn" type="text" size="small" @click="toProjectHeatMapConfig(row)">热力图配置</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="pageList" :page-size="pages.size" layout="total, sizes, prev, pager, next, jumper" :total="total" style="text-align: center;margin-top:20px;"></el-pagination>
        </div>
        <ProjectConfig v-if="active == 0" :projectId="groupId" :projectName="groupName" :isType="isType" @dataType="dataType($event)" @addProjectObj="addProjectObj($event)"></ProjectConfig>
        <ProjectSecondModuleConfig v-if="active == 1" :projectId="groupId" :projectName="groupName"></ProjectSecondModuleConfig>
        <DeviceConfig v-if="active == 2" :projectId="groupId" :projectName="groupName"></DeviceConfig>
        <MetadataConfig v-if="active == 3" :projectId="groupId" :projectName="groupName"></MetadataConfig>
        <DataPanelBinding v-if="active == 4" :projectId="groupId" :projectName="groupName"></DataPanelBinding>
        <!-- <PanelDataPointBinding v-if="active == 3" :projectId="groupId" :projectName="groupName"></PanelDataPointBinding> -->
        <!-- <ProjectTemplateConfig v-if="active == 4" :projectId="groupId" :projectName="groupName"></ProjectTemplateConfig> -->
        <ProjectCellConfig v-if="active == 5" :projectId="groupId" :projectName="groupName"></ProjectCellConfig>
        <ProjectHeatMapConfig v-if="active == 6" :projectId="groupId" :projectName="groupName"></ProjectHeatMapConfig>
        <ProjectGlConfig v-if="active == 7" :projectId="groupId" :projectName="groupName"></ProjectGlConfig>
        <AggregationPointConfig v-if="active == 8" :projectId="groupId" :projectName="groupName"></AggregationPointConfig>
      </div>
    </el-card>
    <!-- 电价组合-->
    <el-drawer title="电价组合" :visible.sync="drawer" direction="rtl" size="50%" :before-close="handleClose" :append-to-body="true">
      <el-form ref="formPrice" :inline="true" :model="formPrice" style="margin:10px;">
        <el-card shadow="never">
          <el-form-item label="电价名称">
            <el-input v-model="formPrice.priceName"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="formPrice.note" type="textarea" :rows="2"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="clearAllData">清空全部</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addProjectPriceInfo(tablePriceData)">保存全部</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addOnePrice">新增一行</el-button>
          </el-form-item>
        </el-card>
      </el-form>
      <div style="margin:10px;">
        <el-table :data="tablePriceData" border style="width: 100%;margin-top:10px;">
          <el-table-column prop="type" label="电价类型">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.kind">
                  <el-option v-for="item in kindOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="峰谷类型">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.type">
                  <el-option v-for="item in peekptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="电价">
            <template slot-scope="{ row }">
              <div>
                <el-input v-model="row.price" type="Number"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="startmonth" label="开始月份">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.startmonth">
                  <el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="endmonth" label="结束月份">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.endmonth">
                  <el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="starttime" label="开始时间">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.starttime">
                  <el-option v-for="(item, index) in 25" :key="index" :label="index + '点'" :value="index"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="endtime" label="结束时间">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.endtime">
                  <el-option v-for="(item, index) in 25" :key="index" :label="index + '点'" :value="index"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <el-button class="btn" size="small" icon="el-icon-delete" @click="deleteProjectPrice(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
  <LocalConfiguration v-if="isLocalConfig" :projectId="groupId" :projectName="groupName" @goBack="goBack($event)"></LocalConfiguration>
  <el-drawer
    title="导出项目列表"
    :visible.sync="isOpen"
    direction="rtl"
    size="50%">
     <el-table :data="gridData">
        <el-table-column property="createTime" label="生成时间"></el-table-column>
        <el-table-column property="state" label="状态">
          <template slot-scope="{ row }">
            {{ statusLocal(row.state) }}
          </template>
        </el-table-column>
        <el-table-column property="url" label="下载地址">
          <template slot-scope="{ row }">
            <el-button type="text" :disabled="row.state!=2" @click="downloadAddress(row)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column property="reason" label="失败原因"></el-table-column>
      </el-table>
      <div style="width:200px;text-align:center;margin:20px auto;">
        <el-button @click="brushLocal">刷新</el-button>
        <el-button type="primary" @click="createLocal">生成</el-button>
      </div>
  </el-drawer>
</div>
</template>

<script>
import PROJECTAPI from '@/api/project';
import GROUPAPI from '@/api/group';
import ProjectConfig from './projectConfig';
import ProjectSecondModuleConfig from './projectsecondmoduleconfig';
import DeviceConfig from './deviceConfig';
import DataPanelBinding from './dataPanelBinding';
// import PanelDataPointBinding from './panelDataPointBinding';
import ProjectAlgorithm from './projectalgorithm';
import ProjectTemplateConfig from './projecttemplateconfig';
import ProjectSecondModuleUpdateOrder from './projectsecondmoduleupdateorder';
import ProjectCellConfig from './projectcellconfig'; //电芯配置
import ProjectHeatMapConfig from './projectheatmapconfig'; //热力图配置
import ProjectGlConfig from './projectglconfig'; //热力图配置
import AggregationPointConfig from './aggregationPointConfig'; //聚合点配置
import LocalConfiguration from './localConfiguration'; //聚合点配置
import MetadataConfig from './metadataConfig'; //元数据配置

export default {
  components: {
    ProjectConfig,
    ProjectSecondModuleConfig,
    DeviceConfig,
    DataPanelBinding,
    // PanelDataPointBinding,
    ProjectAlgorithm,
    ProjectTemplateConfig,
    ProjectSecondModuleUpdateOrder,
    ProjectCellConfig,
    ProjectHeatMapConfig,
    ProjectGlConfig,
    AggregationPointConfig,
    LocalConfiguration,
    MetadataConfig
  },
  data() {
    return {
      active: -1,
      groupId: '',
      groupName: '',
      form: {},
      pages: {
        page: 1,
        size: 10
      },
      pageList: [10, 20, 30, 50, 100],
      total: 0,
      projectStatus: [], //项目状态
      projectShow: [{
        id: 0,
        name: '否'
      }, {
        id: 1,
        name: '是'
      }], //
      productTypeOptions: [], //产品类型
      batteryTypeOptions: [], //电池类型
      manufacturerTypeOptions: [], //使用方类型
      batteryManufacturersOptions: [], //厂商类型
      priceOptions: [], //电价列表
      kindOptions: [], //电价类型
      peekptions: [],
      tableData: [],
      tablePriceData: [],
      formPrice: {},
      drawer: false,
      isType: 'add',
      searchKey: '',
      isLocalConfig: false,
      gridData:[],
      isOpen:false,
      currentRow:{}
    };
  },
  computed: {
    statusDesc(v) {
      let self = this;
      return function (v) {
        let res = '';
        self.projectStatus.forEach(item => {
          if (item.id == v) {
            res = item.name;
          }
        });
        return res;
      };
    },
    statusLocal(v) {
      let listLocal = ['进行中','错误','成功']
	  return function(v){
		  if(v==-1){
		    return '待生成'
		  }else{
		    return listLocal[v]
		  }
	  }
    }
  },
  methods: {
    //导出本地配置
    exportLocal(row){
      this.gridData = []
      this.currentRow = row;
      PROJECTAPI.searchProjectLocalExports({projectId:row.projectId}).then(res=>{
        this.gridData = res.data.data;
      })
      this.isOpen = true
    },
    brushLocal(){
      let row = this.currentRow;
      PROJECTAPI.searchProjectLocalExports({projectId:row.projectId}).then(res=>{
        this.gridData = res.data.data;
      })
    },
    //生成数据
    createLocal(){
      let row = this.currentRow;
      if(row.projectLocalState==0){
        this.$message.success('配置正在生成中...');
      }else{
        PROJECTAPI.exportProjectInfo({projectId:row.projectId}).then(res=>{
          this.$message.success('操作成功');
        })
      }
    },
    //下载生成的数据
    downloadAddress(row){
      if(row.state==2){
        window.open(row.url)
      }
    },
    cellMouseEnter(v,a){
      if(a.label=='生成状态'){
        if(v.projectLocalState==1){
          this.$message.error(v.localReason)
        }
      }
    },
    setActive(v) {
      this.active = v;
      if (v == -1) {
        this.searchProjectPageV2();
      }
    },
    //获取selected的name值
    getSelectedName(val, arr, key, name) {
      return this.COMM.getTypeOptions(val, arr, key, name);
    },
    //关闭电价组合
    handleClose(done) {
      //获取实体数据
      this.searchProjectPriceInfo();
      done();
    },
    //新增电价组合
    openDrawer(row) {
      this.formPrice = {};
      if (row) {
        //实体反选
        this.priceOptions.forEach(item => {
          if (row.priceId == item.id) {
            this.formPrice = item;
          }
        });
        //电价反选
        this.searchProjectPrice(row.priceId, true);
      } else {
        this.drawer = true;
      }
    },
    //查看电价列表
    searchProjectPrice(priceId, flag) {
      let params = {
        priceId: priceId
      };
      PROJECTAPI.searchProjectPrice(params).then(res => {
        if (res.data.code == 200) {
          this.tablePriceData = res.data.data;
          if (flag) {
            this.drawer = true;
          }
        }
      });
    },
    //获取电价组合名称
    getPriceName(v) {
      let res = v;
      this.priceOptions.forEach(item => {
        if (v == item.id) {
          res = item.priceName;
        }
      });
      return res;
    },
    handleSizeChange(v) {
      this.pages.size = v;
      this.searchProjectPageV2();
    },
    handleCurrentChange(v) {
      this.pages.page = v;
      this.searchProjectPageV2();
    },
    //获取切换类型
    getSwitchSearchCodes(number) {
      let self = this;
      let params = {
        codesType: number
      };
      GROUPAPI.searchCodes(params).then(res => {
        if (res.data.code == 200) {
          switch (number) {
            case 1: {
              self.batteryTypeOptions = res.data.data;
              break;
            }
            case 4: {
              self.productTypeOptions = res.data.data;
              break;
            }
            case 7: {
              self.manufacturerTypeOptions = res.data.data;
              break;
            }
            case 2: {
              self.batteryManufacturersOptions = res.data.data;
              break;
            }
            case 25: {
              self.projectStatus = res.data.data;
              break;
            }
            case 24: {
              // self.kindOptions = res.data.data;
              //电价类型0市电电价1备电电价2充电桩电价
              self.kindOptions = [{
                id: 0,
                name: '市电电价'
              }, {
                id: 1,
                name: '备电电价'
              }, {
                id: 2,
                name: '充电桩电价'
              }];
              break;
            }
            case 17: {
              // self.peekptions = res.data.data;
              // 0平值1峰值2谷值 3 尖值
              self.peekptions = [{
                id: 0,
                name: '平值'
              }, {
                id: 1,
                name: '峰值'
              }, {
                id: 2,
                name: '谷值'
              }, {
                id: 3,
                name: '尖值'
              }];
              break;
            }
          }
        }
      });
    },
    //搜索
    searchKeywords(){
      this.pages.page = 1
      this.pages.size = 10
      this.searchProjectPageV2()
    },
    //查询项目列表(带分页)
    searchProjectPageV2() {
      let params = this.pages;
      params.searchKey = this.searchKey;
      let self = this;
      PROJECTAPI.searchProjectPageV2(params).then(res => {
        if (res.data.code == 200 && !res.data.errors) {
          let data = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData = data.map(item => {
            item.edit = false;
            return item;
          });
          this.$nextTick(function () {
            self.$refs.tbl.doLayout();
          });
        }
        if (res.data.errors) {
          this.$message.error(res.data.errors);
        }
      });
    },
    //新增一行
    addRow() {
      this.isType = 'add';
      this.active = 0;
      this.groupId = '';
      this.groupName = '';
    },
    dataType(event) {
      this.isType = event;
    },
    addProjectObj(event) {
      this.groupId = event.projectId;
      this.groupName = event.projectName;
    },
    addOnePrice() {
      var obj = {};
      let has = false;
      let self = this;
      this.tablePriceData.forEach(item => {
        if (item.price == '' || item.price == undefined) {
          has = true;
        }
      });
      if (!has) {
        let index = self.tablePriceData.length + 1;
        obj.index = index;
        self.tablePriceData.push(obj);
      } else {
        this.$message.warning('请完善数据信息！');
      }
    },
    //添加数据
    addProject(row) {
      delete row.isNew;
      let params = row;
      PROJECTAPI.addProject(params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.searchProjectPageV2();
          }
        })
        .catch(() => {
          row.isNew = true;
          //this.searchProjectPageV2();
        });
    },
    //修改一行
    updateProject(row) {
      let params = row;
      PROJECTAPI.updateProject(params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.searchProjectPageV2();
          }
        })
        .catch(err => {
          this.searchProjectPageV2();
        });
    },
    //取消编辑
    cancelEdit(row) {
      this.searchProjectPageV2();
    },
    //确定编辑
    confirmEdit(row) {
      row.originalTitle = row.title;
      if (row.isNew) {
        this.addProject(row);
      } else {
        this.updateProject(row);
      }
    },
    //项目列表-查询电价组合实体列表
    searchProjectPriceInfo() {
      let params = {};
      PROJECTAPI.searchProjectPriceInfo().then(res => {
        if (res.data.code == 200) {
          this.priceOptions = res.data.data;
        }
      });
    },
    //项目列表-新增电价组合实体
    addProjectPriceInfo(tablePriceData) {
      let self = this;
      let params = this.formPrice;
      PROJECTAPI.addProjectPriceInfo(params).then(res => {
        if (res.data.code == 200) {
          if (res.data.data) {
            //生成的实体赋值为编辑状态
            self.formPrice.id = res.data.data.id;
          }
          tablePriceData = tablePriceData.map(item => {
            item.priceId = res.data.data.id;
            return item;
          });
          if (tablePriceData.length > 0) {
            PROJECTAPI.updateBatchProjectPrice(tablePriceData).then(data => {
              self.$message.success('操作成功');
              self.searchProjectPrice(res.data.data.id);
            });
          }
        }
      });
    },
    //删除电价列表数据
    deleteProjectPrice(row) {
      if (row.index) {
        this.tablePriceData.splice(row.index - 1, 1);
        return;
      }
      let params = {
        priceId: row.id
      };
      let self = this;
      this.$confirm('确定要执行此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          PROJECTAPI.deleteProjectPrice(params).then(res => {
            self.searchProjectPrice(row.priceid);
          });
        })
        .catch(() => {});
    },
    //清空所有数据
    clearAllData() {
      this.tablePriceData = [];
    },
    //跳转到项目导入数据
    toProjectConfig(row) {
      this.groupId = row.projectId;
      this.groupName = row.projectName;
      this.isType = 'edit';
      this.active = 0;
    },
    toLocalConfig(row) {
      this.groupId = row.projectId;
      this.groupName = row.projectName;
      this.isLocalConfig = true;
    },
    goBack() {
      this.isLocalConfig = false;
    },
    //跳转到二级模块配置
    toProjectSecondModuleConfig(row) {
      this.groupId = row.projectId;
      this.groupName = row.projectName;
      this.active = 1;
    },
    //跳转到调试顺序
    toProjectUpdateOrder(row) {
      this.groupId = row.projectId;
      this.groupName = row.projectName;
      this.active = 2;
    },
    //跳转到算法配置
    toProjectAlgorithm(row) {
      this.groupId = row.projectId;
      this.groupName = row.projectName;
      this.active = 3;
    },
    //跳转到模板配置
    toProjectTemplateConfig(row) {
      this.groupId = row.projectId;
      this.groupName = row.projectName;
      this.active = 4;
    },
    //跳转到电芯配置
    toProjectCellConfig(row) {
      this.groupId = row.projectId;
      this.groupName = row.projectName;
      this.active = 5;
    },
    //跳转到热力图配置
    toProjectHeatMapConfig(row) {
      this.groupId = row.projectId;
      this.groupName = row.projectName;
      this.active = 6;
    }
  },
  created() {
    //获取项目列表
    this.searchProjectPageV2();
    //获取电池类型
    this.getSwitchSearchCodes(1);
    //获取产品类型
    this.getSwitchSearchCodes(4);
    //获取使用方类型
    this.getSwitchSearchCodes(7);
    //获取电池厂商
    this.getSwitchSearchCodes(2);
    //项目状态
    this.getSwitchSearchCodes(25);
    //获取电价类型
    this.getSwitchSearchCodes(24);
    //获取峰谷类型
    this.getSwitchSearchCodes(17);
    //获取电价组合列表
    this.searchProjectPriceInfo();
  }
};
</script>

<style lang="scss" scoped>
.project {
  .box-card {
    .btn {
      padding: 0px;
      font-size: 12px !important;

      &span {
        font-size: 12px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/index.vue